import React, { useState } from 'react';
import SectionTitle from '../components/section-title';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { Button, Container, Row, Col, Form } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import { parseCookies } from 'nookies';

const AddTreatment = () => {
    //Setto gli state
    const [isCreated, setCreated] = useState(false);
    const [treatment, setTreatment] = useState(null);
    const [showErr, setErr] = useState('');
    const [showSucc, setSucc] = useState('');
    const { register, handleSubmit, errors } = useForm();
    const cookies = parseCookies();

    //Chiamata post per inserimento trattamento
    const onSubmit = data => {
        const name = data.name.toUpperCase().trim();
        const price = data.price;
        const notes = data.notes.trim();

        axios.post(`${window.$apiEndpoint}/treatments/create`, {
            name: name,
            price: price,
            notes: notes
        }, {
            headers: {
                'x-access-token': cookies.token
            }
        })
            .then(res => {
                setTreatment(res.data)
                //Setto un Timeout per la risposta
                setTimeout(() => { setCreated(true) }, 3000)
                setSucc('Trattamento creato con successo. A breve verrete reindirizzati sulla pagina dei trattamenti.')
            }).catch(err => {
                const status = err.response?.status;
                const msg =
                    status === 404 ? "Endpoint non trovato (404): controlla base URL e app.use()"
                        : status === 409 ? "Il trattamento risulta già esistente"
                            : err.response?.data?.message || err.message;

                setErr(msg);
            });
    }

    //Se lo state isCreated é true eseguo il redirect alla pagina profilo utente
    if (isCreated) {
        // redirect to home if signed up
        //Sleep 1
        return <Redirect to={`/treatments`} />;
    }

    return (
        <>
            <SectionTitle title="Inserisci" subtitle="Crea nuovo trattamento" />

            <Container fluid>
                <Row>
                    <Col xs={12}>
                        <div className="card border-left-warning  shadow h-100 py-6 px-4">
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Form.Row>
                                    <Form.Group controlId="name" as={Col} >
                                        <Form.Label>Nome trattamento</Form.Label>
                                        <Form.Control type="text" name="name" ref={register()} placeholder="Inserisci Nome" />
                                        {errors.name && <p style={{ marginTop: '1vh', fontWeight: 'bold', color: '#f15a24' }}>Il campo è obbligatorio</p>}
                                    </Form.Group>

                                    <Form.Group controlId="price" as={Col} >
                                        <Form.Label>Tariffa <strong style={{ color: '#f55353' }}> (Inserire il punto come separatore numerico es. 39.50)</strong></Form.Label>
                                        <Form.Control type="text" name="price" ref={register({ required: true })} placeholder="Inserisci Tariffa" />
                                        {errors.price && <p style={{ marginTop: '1vh', fontWeight: 'bold', color: '#f15a24' }}>Il campo è obbligatorio</p>}
                                    </Form.Group>
                                    <Form.Group controlId="notes" as={Col} >
                                        <Form.Label>Note</Form.Label>
                                        <Form.Control type="text" name="notes" ref={register()} placeholder="Inserisci Note" />
                                        {errors.notes && <p style={{ marginTop: '1vh', fontWeight: 'bold', color: '#f15a24' }}>Il campo è obbligatorio</p>}
                                    </Form.Group>
                                </Form.Row>

                                <p className="my-2" style={{ fontWeight: 'bold', color: 'red' }}>{showErr}</p>
                                <p className="my-2" style={{ fontWeight: 'bold', color: 'green' }}>{showSucc}</p>

                                <Button variant="info" size="md" type="submit" style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: '600' }}>
                                    Crea Trattamento
                                </Button>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default AddTreatment;